<template>
    <div class="tips" v-if="!isPdf">
        <el-alert v-for="e in $store.state.errors" :key="e.key" :title="e.message" type="error" :closable="false"></el-alert>
    </div>
    <div class="mcjs" id="mcjs" v-loading.fullscreen.lock="loading">
        <p v-for="(item,idx) in mcjs" :key="idx">
            <b class="title">{{intToChinese(idx+1)}}、{{item.title || item.lei+'（类）'+item.kuan+'（款）'+item.xiang+'（项）'}}：</b>
            <reason type="textarea" classname="qksm widest" :name="'mcjs_'+(item.code ? item.code : idx+1)" v-model:value="item.desc"></reason>
        </p>
    </div>
</template>
<script>
    import reason from '@/components/reason.vue'
    import { getDivList, getKemuQuery } from '@/api/index.js'
    import { getBdata } from "@/api/zone.js";
    export default {
        name: 'mcjs',
        components: {
            reason
        },
        props: {
            qksmData: {
                type: Object,
                default: {}
            },
            tableData: {
                type: Object,
                default: {}
            },
            bdata: {
                type: Object,
                default: {}
            },
        },
        data() {
            return {
                loading: true,
                isId: false,
                mcjs: [],
                qksm: {},
                tables: [],
                kemu: [],
                isPdf: Boolean,
                mcjsObject: [],
                name: 'mcjs',
                fixedItem: [{
                    title: "财政拨款收入",
                    desc: "指单位本年度从同级财政部门取得的各类财政拨款。",
                }, {
                    title: "上级补助收入",
                    desc: "指事业单位从主管部门和上级单位取得的非财政补助收入。",
                }, {
                    title: "事业收入",
                    desc: "指事业单位开展专业业务活动及其辅助活动取得的收入，事业单位收到的财政专户实际核拨的教育收费等资金在此反映。",
                }, {
                    title: "经营收入",
                    desc: "指事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入。",
                }, {
                    title: "附属单位上缴收入",
                    desc: "指事业单位附属独立核算单位按照有关规定上缴的收入。",
                }, {
                    title: "其他收入",
                    desc: "指单位取得的除上述“财政拨款收入”、“事业收入”、“经营收入”等以外的各项收入。",
                }, {
                    title: "使用非财政拨款结余",
                    desc: "指事业单位使用非财政拨款结余（原事业基金）弥补当年收支差额的数额。",
                }, {
                    title: "年初结转和结余",
                    desc: "指单位上年结转本年使用的基本支出结转、项目支出结转和结余和经营结余。",
                }, {
                    title: "结余分配",
                    desc: "指事业单位按规定对非财政拨款结余资金提取的专用基金、缴纳的所得税和转入非财政拨款结余等。",
                }, {
                    title: "年末结转和结余资金",
                    desc: "指本年度或以前年度预算安排、因客观条件发生变化无法按原计划实施，需要延迟到以后年度按有关规定继续使用的资金。",
                }, {
                    title: "基本支出",
                    desc: "指为保障机构正常运转、完成日常工作任务而发生的支出，包括人员经费和公用经费。",
                }, {
                    title: "项目支出",
                    desc: "指在为完成特定的工作任务和事业发展目标所发生的支出。",
                }, {
                    title: "上缴上级支出",
                    desc: "指事业单位按照财政部门和主管部门的规定上缴上级单位的支出。",
                }, {
                    title: "经营支出",
                    desc: "指事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动发生的支出。",
                }, {
                    title: "对附属单位补助支出",
                    desc: "指事业单位用财政拨款收入之外的收入对附属单位补助发生的支出。",
                }, {
                    title: "“三公”经费",
                    desc: "指部门用一般公共预算财政拨款安排的因公出国（境）费、公务用车购置及运行维护费和公务接待费。其中，因公出国（境）费反映单位公务出国（境）的国际旅费、国外城市间交通费、住宿费、伙食费、培训费、公杂费等支出；公务用车购置及运行维护费反映单位公务用车购置支出（含车辆购置税、牌照费）以及按规定保留的公务用车燃料费、维修费、过路过桥费、保险费、安全奖励费用等支出；公务接待费反映单位按规定开支的各类公务接待（含外宾接待）费用。",
                }, {
                    title: "机关运行经费",
                    desc: "指行政单位（含参照公务员法管理的事业单位）使用一般公共预算安排的基本支出中的公用经费支出，包括办公及印刷费、邮电费、差旅费、会议费、福利费、日常维修费、专用材料及一般设备购置费、办公用房水电费、办公用房取暖费、办公用房物业管理费、公务用车运行维护费及其他费用。",
                }]
            };
        },
        mounted() {
            var qksm = this.$store.state.divData.qksm;
            let that=this
            this.fixedItem.forEach(function (item, index) {
                item.desc = that.pickOneOf(qksm['mcjs_' + (index+1)], item.desc)
            })
            if (this.$parent.isPdf) {
                this.loading = false
                this.isPdf = true
                this.qksm = this.qksmData
                this.tables = this.tableData;
                this.mcjs = this.fixedItem;
                this.mcjsObject = this.preview(this.bdata.find(e => e.name == "mcjs").expr).result;
                this.getTableData();
            } else {
                this.isPdf = false
                this.getDivData()
            }
        },
        methods: {
            getDivData() {
                this.loading = true;
                getDivList({ id: this.$route.query.divid }).then((res) => {
                    this.qksm = res.qksm;
                    this.tables = res.tables;
                    getBdata().then((res) => {
                        if (res.status == 0) {
                            this.mcjs = this.fixedItem
                            this.mcjsObject = this.preview(res.bdata.find(e => e.name == "mcjs").expr).result;
                            this.getTableData();
                        }
                        this.loading = false
                    })
                })

            },
            getTableData() {
                if (JSON.stringify(this.mcjsObject) == "[]" || this.mcjsObject.length == 0) {
                    return
                }
                getKemuQuery({ codes: this.mcjsObject.map(e => { return e.code }).join(",") }).then((kemuRes) => {
                    try {
                        if (kemuRes.status == 0) {
                            for (let item of this.mcjsObject) {
                                let desc = this.qksm['mcjs_' + item.code]
                                if (desc == null || desc == undefined) {
                                    let code = item.code
                                    let thisKemu = kemuRes.list.find(e => e.code == code)
                                    if (thisKemu)
                                        desc = thisKemu.explain
                                    else {
                                        throw '找不到解释项：' + code
                                    }
                                }
                                this.mcjs.push({
                                    code: item.code,
                                    lei: item.lei,
                                    kuan: item.kuan,
                                    xiang: item.name,
                                    desc: desc
                                })
                            }
                        }
                    }
                    catch (ex) {
                        this.addOrSet('mcjs', '名词解释存在数据错误，请检查。' + ex)
                    }
                })
                this.loading = false;
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
        },
    }
</script>
<style scoped>
    .mcjs p b {
        font-family: SimHei !important;
    }

    .mcjs p {
        line-height: 2em;
        font-family: FangSong;
        font-size: 20px;
    }
</style>